import React, { PropTypes } from 'react';
import { NitroHeading, NitroButton, NitroDivider, NitroPanel, NitroParagraph } from 'nitro-components';

import Status from '../../components/utils/Status';

import styled from 'styled-components';
import { media } from 'style-utils';

const Heading = styled.div`
  margin: 40px 0;
`;

const Panel = styled.div`
  text-align: center;
  min-height: 600px;
`;

const PanelContent = styled.div`
  margin: 40px auto;
  max-width: 50%;
  ${media.mobile`
    max-width: 100%;
  `}
`;

const Message = styled.div`
  margin: 50px 0 100px;
`;

const GenericError = ({ headindText, messageDetail, formattedErrorStatus, actionHandler }) => {
  return (
    <div>
      <Heading>
        <NitroHeading label={headindText} variant="secondary" align="center" size="1" />
      </Heading>
      <Panel>
        <NitroPanel>

          <PanelContent>

            <Status iconSize="48" labelSize="2" {...formattedErrorStatus} />

            <NitroDivider sidePanel />
            <Message>
              <NitroParagraph variant="base3" align="center">{messageDetail}</NitroParagraph>
            </Message>
            <NitroButton size="small" width="block" label={actionHandler.label} action={actionHandler.action} />
          </PanelContent>

        </NitroPanel>
      </Panel>
    </div>
  );
};

GenericError.propTypes = {
  headindText: PropTypes.string.isRequired,
  messageDetail: PropTypes.string.isRequired,
  formattedErrorStatus: PropTypes.object.isRequired,
  closeWindow: PropTypes.func,
  actionHandler: PropTypes.object
};

export default GenericError;



// WEBPACK FOOTER //
// ./src/features/errors/GenericError.js